module.exports = __webpack_public_path__ + "static/media/Acrilico (36).e7a35d97.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Acrilico/Acrilico (36).jpg
// module id = 304
// module chunks = 0